<div class="sectionContainer paddedContent containerMargins">
  <div class="formSection">
    <div class="formRow">
      <app-multiline-input
        [label]="'Notes'"
        [required]="false"
        [(ngModel)]="notes"
        [helpText]="
          'This is just a sample of how we can add contextual help for a specific form field.'
        "
        [readonly]="false"
      ></app-multiline-input>
    </div>
  </div>

  <div class="sectionContainer paddedContent containerMargins">
    <div class="formSection">
      <div class="sectionHeader">Processing Profile</div>

      <div class="formRow">
        <app-text-input
          [label]="'Current processor'"
          [readonly]="false"
          [required]="false"
        ></app-text-input>
        <app-text-input
          [label]="'Current pricing'"
          [type]="inputTextModes.CurrencyUSD"
          [validateOn]="'change'"
          [minNumericValue]="0"
          [readonly]="false"
          [required]="false"
        ></app-text-input>
      </div>

      <div class="formRow">
        <app-multiline-input
          [label]="'Current Process'"
          [readonly]="false"
          [required]="false"
        ></app-multiline-input>
        <app-multiline-input
          [label]="'Integrated Software'"
          [readonly]="false"
          [required]="false"
        ></app-multiline-input>
        <app-multiline-input
          [label]="'Business Description'"
          [readonly]="false"
          [required]="false"
        ></app-multiline-input>
      </div>
    </div>
  </div>

  <div class="sectionContainer paddedContent containerMargins">
    <div class="formSection">
      <div class="sectionHeader">Payments will be taken</div>

      <div class="formRow">
        <app-check-input
          [label]="'In Person with terminal'"
          [required]="false"
          [helpText]="'here is some help text'"
          [readonly]="false"
        ></app-check-input>
        <app-check-input
          [label]="'E-Commerce'"
          [readonly]="false"
        ></app-check-input>
        <app-check-input
          [label]="'By phone'"
          [readonly]="false"
        ></app-check-input>
        <app-check-input
          [label]="'e-Invoice'"
          [readonly]="false"
        ></app-check-input>
        <app-check-input
          [label]="'Virtual Terminal'"
          [readonly]="false"
        ></app-check-input>
        <app-check-input [label]="'ACH'" [readonly]="false"></app-check-input>
      </div>
    </div>
  </div>

  <div class="sectionContainer paddedContent containerMargins">
    <div class="formSection" style="width: 50%; min-width: 500px">
      <div class="sectionHeader">Gateway</div>

      <div class="formRow">
        <app-ddl-input
          [label]="'Gateway Provider'"
          [style]="'min-width:200px;'"
          [options]="gatewayOptions"
          [readonly]="false"
        ></app-ddl-input>
      </div>

      <div
        style="display: flex; flex-grow: 0; gap: 10px"
        id="virtualTerminalOptions"
      >
        <div style="flex: 1">
          <app-check-input
            [label]="'Virtual Terminal'"
            (onChanged)="toggleVirtualTerminalOptions($event)"
            [readonly]="false"
          ></app-check-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Monthly fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Per trans fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
      </div>

      <div style="display: flex; flex-grow: 0; gap: 10px">
        <div style="flex: 1">
          <app-check-input
            [label]="'Customer Vault'"
            [readonly]="false"
          ></app-check-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Monthly fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Per trans fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
      </div>

      <div style="display: flex; flex-grow: 0; gap: 10px">
        <div style="flex: 1">
          <app-check-input
            [label]="'Invoicing'"
            [readonly]="false"
          ></app-check-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Monthly fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Per trans fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
      </div>

      <div style="display: flex; flex-grow: 0; gap: 10px">
        <div style="flex: 1">
          <app-check-input
            [label]="'Automatic Card Updater'"
            [readonly]="false"
          ></app-check-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Monthly fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Per trans fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
      </div>

      <div style="display: flex; flex-grow: 0; gap: 10px">
        <div style="flex: 1">
          <app-check-input
            [label]="'Mobile App Access'"
            [readonly]="false"
          ></app-check-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Monthly fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Per trans fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
      </div>

      <div>
        <app-check-input
          [label]="'Token Transfer Needed'"
          [readonly]="false"
        ></app-check-input>
      </div>
    </div>
  </div>

  <div class="sectionContainer paddedContent containerMargins">
    <div class="formSection" style="width: 50%; min-width: 500px">
      <div class="sectionHeader">ACH</div>

      <div>
        <app-ddl-input
          [label]="'Processor'"
          [options]="achProcessorOptions"
          [readonly]="false"
        ></app-ddl-input>
      </div>

      <div>
        <app-multiline-input [label]="'Pricing notes'"></app-multiline-input>
      </div>

      <div style="display: flex; flex-grow: 0; gap: 10px">
        <div style="flex: 1">
          <app-check-input
            [label]="'Virtual Terminal'"
            [readonly]="false"
          ></app-check-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Monthly fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Per trans fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
      </div>

      <div style="display: flex; flex-grow: 0; gap: 10px">
        <div style="flex: 1">
          <app-check-input
            [label]="'Customer Vault'"
            [readonly]="false"
          ></app-check-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Monthly fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Per trans fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
      </div>

      <div style="display: flex; flex-grow: 0; gap: 10px">
        <div style="flex: 1">
          <app-check-input
            [label]="'Invoicing'"
            [readonly]="false"
          ></app-check-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Monthly fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Per trans fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
      </div>

      <div style="display: flex; flex-grow: 0; gap: 10px">
        <div style="flex: 1">
          <app-check-input
            [label]="'Automatic Card Updater'"
            [readonly]="false"
          ></app-check-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Monthly fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Per trans fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
      </div>

      <div style="display: flex; flex-grow: 0; gap: 10px">
        <div style="flex: 1">
          <app-check-input
            [label]="'Mobile App Access'"
            [readonly]="false"
          ></app-check-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Monthly fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
        <div style="flex: 1">
          <app-text-input
            [label]="'Per trans fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
          ></app-text-input>
        </div>
      </div>
    </div>
  </div>

  <div class="sectionContainer paddedContent containerMargins">
    <div class="formSection">
      <div class="sectionHeader">Physical Equipment</div>

      <div class="formRow">
        <app-ddl-input
          [label]="'Equipment?'"
          [options]="equipmentOptions"
          [readonly]="false"
        ></app-ddl-input>
      </div>

      <div class="formRow">
        <app-multiline-input
          [label]="'Current equipment'"
          [readonly]="false"
        ></app-multiline-input>
      </div>

      <div class="formRow">
        <app-text-input
          [label]="'Equipment cost'"
          [type]="inputTextModes.CurrencyUSD"
          [readonly]="false"
        ></app-text-input>
        <app-text-input
          [label]="'Quantity'"
          [type]="inputTextModes.Numeric"
          [readonly]="false"
        ></app-text-input>
      </div>

      <div class="formRow">
        <app-ddl-input
          [label]="'Buy or Rent'"
          style="width: 100px"
          [options]="equipmentOwnershipOptions"
          [readonly]="false"
        ></app-ddl-input>
      </div>

      <div class="formRow">
        <app-multiline-input
          [label]="'Equipment description'"
          [readonly]="false"
        ></app-multiline-input>
      </div>

      <div class="formSection">
        <div class="sectionHeader">Terminal Info</div>

        <div class="formRow">
          <app-text-input
            [label]="'Model'"
            [readonly]="false"
            [required]="false"
          ></app-text-input>
          <app-text-input
            [label]="'Version/SIM#'"
            [readonly]="false"
            [required]="false"
          ></app-text-input>
        </div>
        <div class="formRow">
          <app-text-input
            [label]="'Code'"
            [readonly]="false"
            [required]="false"
          ></app-text-input>
        </div>
      </div>
    </div>
  </div>

  <div class="sectionContainer paddedContent containerMargins">
    @if (solution.pricing && solution.pricing.structure) {
      <div class="formSection containerMargins">
        <div class="sectionHeader">Credit card pricing info</div>
        <div class="formRow">
          <app-ddl-input
            [label]="'Pricing structure'"
            style="width: 150px"
            [options]="pricingStructureOptions"
            [(ngModel)]="solution.pricing.structure"
            [readonly]="false"
            [required]="false"
          />
        </div>
        <div style="font-size: 0.9em">
          <!-- Flat rate -->
          <div
            style="width: 250px"
            [hidden]="solution.pricing.structure != pricingStructure.FlatRate"
          >
            <div class="formRow">
              <div>Rate</div>
              <div>Per Item</div>
            </div>
            <div class="formRow">
              <div><app-text-input [type]="inputTextModes.Percent" /></div>
              <div><app-text-input [type]="inputTextModes.CurrencyUSD" /></div>
            </div>
          </div>
          <style>
            .field-money {
              width: 80px;
            }
          </style>
          <!-- Interchange+ -->
          <div
            class="flex-container"
            style="align-items: center"
            [hidden]="solution.pricing.structure != pricingStructure.CostPlus"
          >
            <div style="flex: 1">
              <div class="column">MARKUP</div>
            </div>
            <div
              style="
                flex: 2;
                border: 1px solid #dddddd;
                border-radius: 6px;
                padding: 6px;
              "
            >
              <div
                style="
                  text-align: center;
                  margin: 6px 0px;
                  padding: 5px;
                  background-color: #3399cc;
                  color: #ffffff;
                "
              >
                VISA
              </div>
              <div
                class="flex-container"
                style="flex-grow: 0; align-items: top"
              >
                <div>
                  <app-text-input
                    class="field-money"
                    [type]="inputTextModes.Percent"
                  />
                </div>
                <div>
                  <app-text-input
                    class="field-money"
                    [type]="inputTextModes.CurrencyUSD"
                  />
                </div>
              </div>
            </div>
            <div
              style="
                flex: 2;
                border: 1px solid #dddddd;
                border-radius: 6px;
                padding: 6px;
              "
            >
              <div
                style="
                  text-align: center;
                  margin: 6px 0px;
                  padding: 5px;
                  background-color: #3399cc;
                  color: #ffffff;
                "
              >
                MASTERCARD
              </div>
              <div class="flex-container" style="flex-grow: 0">
                <div>
                  <app-text-input
                    class="field-money"
                    [type]="inputTextModes.Percent"
                  />
                </div>
                <div>
                  <app-text-input
                    class="field-money"
                    [type]="inputTextModes.CurrencyUSD"
                  />
                </div>
              </div>
            </div>
            <div
              style="
                flex: 2;
                border: 1px solid #dddddd;
                border-radius: 6px;
                padding: 6px;
              "
            >
              <div
                style="
                  text-align: center;
                  margin: 6px 0px;
                  padding: 5px;
                  background-color: #3399cc;
                  color: #ffffff;
                "
              >
                DISCOVER
              </div>
              <div class="flex-container" style="flex-grow: 0">
                <div>
                  <app-text-input
                    class="field-money"
                    [type]="inputTextModes.Percent"
                  />
                </div>
                <div>
                  <app-text-input
                    class="field-money"
                    [type]="inputTextModes.CurrencyUSD"
                  />
                </div>
              </div>
            </div>
            <div
              style="
                flex: 2;
                border: 1px solid #dddddd;
                border-radius: 6px;
                padding: 6px;
              "
            >
              <div
                style="
                  text-align: center;
                  margin: 6px 0px;
                  padding: 5px;
                  background-color: #3399cc;
                  color: #ffffff;
                "
              >
                UNION PAY
              </div>
              <div class="flex-container" style="flex-grow: 0">
                <div>
                  <app-text-input
                    class="field-money"
                    [type]="inputTextModes.Percent"
                  />
                </div>
                <div>
                  <app-text-input
                    class="field-money"
                    [type]="inputTextModes.CurrencyUSD"
                  />
                </div>
              </div>
            </div>
            <div
              style="
                flex: 2;
                border: 1px solid #dddddd;
                border-radius: 6px;
                padding: 6px;
              "
            >
              <div
                style="
                  text-align: center;
                  margin: 6px 0px;
                  padding: 5px;
                  background-color: #3399cc;
                  color: #ffffff;
                "
              >
                AMERICAN EXPRESS
              </div>
              <div class="flex-container" style="flex-grow: 0">
                <div>
                  <app-text-input
                    class="field-money"
                    [type]="inputTextModes.Percent"
                  />
                </div>
                <div>
                  <app-text-input
                    class="field-money"
                    [type]="inputTextModes.CurrencyUSD"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex-container"
            [hidden]="solution.pricing.structure != pricingStructure.Tiered"
          >
            <div
              style="
                flex: 3;
                border: 1px solid #dddddd;
                border-radius: 6px;
                padding: 6px;
              "
            >
              <div
                style="
                  text-align: center;
                  font-weight: bold;
                  margin-bottom: 10px;
                  padding: 5px;
                  background-color: #3399cc;
                  color: #ffffff;
                "
              >
                VISA
              </div>
              <div class="flex-container">
                <div style="flex: 1"></div>
                <div style="flex: 1">Rate</div>
                <div style="flex: 1">Per Item</div>
              </div>
              <div class="flex-container">
                <div style="flex: 1">QUALIFIED</div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.Percent" />
                </div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div style="flex: 1">MID QUALIFIED</div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.Percent" />
                </div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div style="flex: 1">NON QUALIFIED</div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.Percent" />
                </div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div style="flex: 1">STANDARD</div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.Percent" />
                </div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div style="flex: 1">OTHER</div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.Percent" />
                </div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div style="flex: 1">REWARDS</div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.Percent" />
                </div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div style="flex: 1">COMMERCIAL CARD</div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.Percent" />
                </div>
                <div style="flex: 1">
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
            </div>
            <div
              style="
                flex: 2;
                border: 1px solid #dddddd;
                border-radius: 6px;
                padding: 6px;
              "
            >
              <div
                style="
                  text-align: center;
                  font-weight: bold;
                  margin-bottom: 10px;
                  padding: 5px;
                  background-color: #3399cc;
                  color: #ffffff;
                "
              >
                MASTERCARD
              </div>
              <div class="flex-container">
                <div style="flex: 1">Rate</div>
                <div style="flex: 1">Per Item</div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
            </div>
            <div
              style="
                flex: 2;
                border: 1px solid #dddddd;
                border-radius: 6px;
                padding: 6px;
              "
            >
              <div
                style="
                  text-align: center;
                  font-weight: bold;
                  margin-bottom: 10px;
                  padding: 5px;
                  background-color: #3399cc;
                  color: #ffffff;
                "
              >
                DISCOVER
              </div>
              <div class="flex-container">
                <div style="flex: 1">Rate</div>
                <div style="flex: 1">Per Item</div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
            </div>
            <div
              style="
                flex: 2;
                border: 1px solid #dddddd;
                border-radius: 6px;
                padding: 6px;
              "
            >
              <div
                style="
                  text-align: center;
                  font-weight: bold;
                  margin-bottom: 10px;
                  padding: 5px;
                  background-color: #3399cc;
                  color: #ffffff;
                "
              >
                UNION PAY
              </div>
              <div class="flex-container">
                <div style="flex: 1">Rate</div>
                <div style="flex: 1">Per Item</div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
            </div>
            <div
              style="
                flex: 2;
                border: 1px solid #dddddd;
                border-radius: 6px;
                padding: 6px;
              "
            >
              <div
                style="
                  text-align: center;
                  font-weight: bold;
                  margin-bottom: 10px;
                  padding: 5px;
                  background-color: #3399cc;
                  color: #ffffff;
                "
              >
                AMERICAN EXPRESS
              </div>
              <div class="flex-container">
                <div style="flex: 1">Rate</div>
                <div style="flex: 1">Per Item</div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
              <div class="flex-container">
                <div><app-text-input [type]="inputTextModes.Percent" /></div>
                <div>
                  <app-text-input [type]="inputTextModes.CurrencyUSD" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="sectionContainer paddedContent containerMargins">
    <div class="formSection containerMargins">
      <div class="sectionHeader">Account Fees</div>

      <div class="formRow">
        <app-text-input
          [label]="'Application fee'"
          [type]="inputTextModes.CurrencyUSD"
          [readonly]="false"
        ></app-text-input>
        <app-text-input
          [label]="'Installation/Training'"
          [type]="inputTextModes.CurrencyUSD"
          [readonly]="false"
        ></app-text-input>
        <app-text-input
          [label]="'Account Maintenance'"
          [type]="inputTextModes.CurrencyUSD"
          [readonly]="false"
        ></app-text-input>
      </div>
      <div class="formRow">
        <app-text-input
          [label]="'Annual Fee'"
          [type]="inputTextModes.CurrencyUSD"
          [readonly]="false"
        ></app-text-input>
        <app-text-input
          [label]="'Monthly Min'"
          [type]="inputTextModes.CurrencyUSD"
          [readonly]="false"
        ></app-text-input>
        <app-text-input
          [label]="'Monthly service fee'"
          [type]="inputTextModes.CurrencyUSD"
          [readonly]="false"
        ></app-text-input>
      </div>
      <div class="formRow">
        <app-text-input
          [label]="'Return Item Fees/NSF (per occur)'"
          [type]="inputTextModes.CurrencyUSD"
          [readonly]="false"
        ></app-text-input>
        <app-text-input
          [label]="'Chargeback (per occur)'"
          [type]="inputTextModes.CurrencyUSD"
          [readonly]="false"
        ></app-text-input>
      </div>
    </div>

    <div>
      <input type="button" class="button_secondary button_var_2" value="Save" />
    </div>
  </div>
</div>
